
  <header role="banner" class="navbar navbar-dark bg-dark navbar-expand-md supra">
    <nav class="container-fluid">
      <ul class="navbar-nav ml-auto">
          <li class="nav-item" ngbDropdown *ngIf="userObject">
            <button class="btn btn-link nav-link" id="dropdownLanguage" ngbDropdownToggle>
              {{userObject.name}}&nbsp;
              <fa-icon icon="user"></fa-icon>
            </button>
            <ul ngbDropdownMenu aria-labelledby="dropdownLanguage">
              <li *ngIf="changeTenants">
                <a ngbDropdownItem routerLink="/tenants">Change tenant</a>
              </li>
              <li>
                <a ngbDropdownItem (click)="logout()">Logout</a>
              </li>
            </ul>
          </li>
          <li class="nav-item" ngbDropdown>
            <button class="btn btn-link nav-link" id="dropdownLanguage" ngbDropdownToggle>{{selectRegion.name}}</button>
            <ul ngbDropdownMenu aria-labelledby="dropdownLanguage">
              <li *ngFor="let region of regions">
                <a ngbDropdownItem
                  [class.active]= "region.current"
                  attr.aria-label={{region.name}}
                  attr.aria-current={{region.current}}
                  hreflang={{region.name}}
                  (click)="changeRegion(region)">{{region.name}}</a>
              </li>
            </ul>
          </li>
          <li class="nav-item" ngbDropdown>
            <button class="btn btn-link nav-link" id="dropdownLanguage" ngbDropdownToggle>{{selectLanguage.name}}</button>
            <ul ngbDropdownMenu aria-labelledby="dropdownLanguage">
              <li *ngFor="let language of languages">
                <a ngbDropdownItem
                  [class.active]= "language.current"
                  attr.aria-label={{language.label}}
                  attr.aria-current={{language.current}} lang={{language.lang}}
                  hreflang={{language.lang}}
                  (click)="changeLanguage(language)">{{language.name}}</a>
              </li>
            </ul>
          </li>
      </ul>
    </nav>
  </header>

  <header role="banner" class="navbar navbar-dark bg-dark navbar-expand-lg">
    <nav role="navigation" class="container-fluid">

      <a class="navbar-brand" href="#">
          <img src="assets/images/Small_Logo_RGB.png" alt="Back to homepage" title="Back to homepage">
          <!-- orange_logo.svg -->
      </a>

      <button class="navbar-toggler" type="button" (click)="toggleCollapseNav()"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
      </button>

      <div class="navbar-collapse" id="navbarSupportedContent" [ngClass]="isCollapsedNav ? 'collapse' : ''">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
              <a class="nav-link"
                  routerLinkActive="active"
                  #navbarRouterLink="routerLinkActive"
                  [attr.aria-current]="navbarRouterLink.isActive ? 'page': undefined"
                  routerLink="/dashboard">{{ 'menu.dashboard' | translate }}</a>
          </li>
          <li class="nav-item" ngbDropdown>
            <button class="btn btn-link nav-link" id="dropdownBasic1" ngbDropdownToggle>{{ 'menu.support.title' | translate }}</button>
            <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <li><a ngbDropdownItem routerLink="/support/dashboard">{{ 'menu.support.overview' | translate }} </a></li>
              <li><a ngbDropdownItem routerLink="/support/log">{{ 'menu.support.log' | translate }} </a></li>
            </ul>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLinkActive="active" #navbarRouterLink="routerLinkActive"
            [attr.aria-current]="navbarRouterLink.isActive ? 'page': undefined" routerLink="/activity/dashboard">{{ 'menu.activity.title' | translate }}</a>
          </li>
          <!-- <li class="nav-item" ngbDropdown>
            <button class="btn btn-link nav-link" id="dropdownBasic1" ngbDropdownToggle>{{ 'menu.activity.title' | translate }}</button>
            <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <li><a ngbDropdownItem routerLink="/activity/dashboard">{{ 'menu.activity.overview' | translate }} </a></li>
              <li><a ngbDropdownItem routerLink="/activity/search">{{ 'menu.activity.search' | translate }} </a></li>
            </ul>
          </li>  -->
          <li class="nav-item">
              <a class="nav-link" routerLinkActive="active" #navbarRouterLink="routerLinkActive"
              [attr.aria-current]="navbarRouterLink.isActive ? 'page': undefined" routerLink="/asset/dashboard">{{ 'menu.assets.title' | translate }}</a>
          </li>
          <li class="nav-item" ngbDropdown>
            <button class="btn btn-link nav-link" id="dropdownBasic1" ngbDropdownToggle>{{ 'menu.reports.title' | translate }}</button>
            <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <li><a ngbDropdownItem routerLink="/reports/standard">{{ 'menu.reports.standard' | translate }} </a></li>
              <li><a ngbDropdownItem routerLink="/reports/live/securitycase">{{ 'menu.reports.securityCase' | translate }} </a></li> 
            </ul>
          </li> 
          <li class="nav-item" ngbDropdown>
            <button class="btn btn-link nav-link" id="dropdownBasic1" ngbDropdownToggle>{{ 'menu.updates.title' | translate }}</button>
            <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <li><a ngbDropdownItem routerLink="/updates/services">{{ 'menu.updates.ourServices' | translate }}</a></li>
              <li><a ngbDropdownItem routerLink="/updates/worldwatch/dashboard">{{ 'menu.updates.worldwatch' | translate }}</a></li>
              <li><a ngbDropdownItem routerLink="/updates/vulnerabilities/dashboard">{{ 'menu.updates.vulnerabilities' | translate }}</a></li>
              <li><a ngbDropdownItem routerLink="/updates/blogs">{{ 'menu.updates.rss.blog' | translate }}</a></li>
              <li><a ngbDropdownItem routerLink="/updates/events">{{ 'menu.updates.rss.events' | translate }}</a></li>
              <li><a ngbDropdownItem routerLink="/updates/news">{{ 'menu.updates.rss.news' | translate }}</a></li>
              <li><a ngbDropdownItem routerLink="/updates/whitepapers">{{ 'menu.updates.rss.whitepapers' | translate }}</a></li>
            </ul>
          </li>
          <li class="nav-item" ngbDropdown>
            <button class="btn btn-link nav-link" id="dropdownBasic1" ngbDropdownToggle>Links</button>
            <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <li><a ngbDropdownItem target="_new" href="https://cert.orangecyberdefense.com/" rel="noopener noreferrer">Threat Defense Center</a></li>
            </ul>
          </li> 
          <li class="nav-item" ngbDropdown *ngIf="userAdmin">
            <button class="btn btn-link nav-link" id="dropdownBasic1" ngbDropdownToggle>Admin</button>
            <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <li><a ngbDropdownItem routerLink="/user/management">Users</a></li>
            </ul>
          </li> 
        </ul>
        <ul class="navbar-nav flex-row ml-md-auto d-md-flex align-items-center logTicket">
          <li class="nav-item">
              <a href="#" class="btn btn-primary" routerLink="/support/log" >{{ 'buttons.logticket' | translate }}</a>
          </li>
        </ul>
      </div>
    </nav>
  </header>


  <!-- <div class="row">
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
    <div class="col-xl-10 col-lg-10 col-12">
      <div class="">
        <app-breadcrumb></app-breadcrumb>
      </div>
    </div>
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
  </div> -->



  <div class="row m-0 p-0">
    <div class="col-xl-12 p-0">
      <div>
        <app-banner></app-banner>
      </div>
    </div>
  </div>

  <div class="row p-2">
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
    <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 col-xs-12">
      <app-error></app-error>
    </div>
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
  </div>

  <div class="row p-0">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0">
      <div class="pt-2">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

  <a (click)="scrollUp()" class="o-scroll-up pl-0" title="back to top">
    <span class="d-none d-sm-inline-block"></span>
  </a>

  <div class="o-footer mt-0" role="contentinfo">
    <h2 class="sr-only">Site map & informations</h2>
    <div class="o-footer-top">
        <div class="container">
            <div class="row mb-0 pb-1">
              If you identify a bug, or have issues with this portal please email us at &nbsp;<a href="mailto:portalsupport@orangecyberdefense.com"> portalsupport@orangecyberdefense.com</a>
            </div>
            <div class="row mb-0" style="float:left">
                <ul class="nav align-items-center">
                  <li class="nav-item"><span class="nav-link">Follow us:</span></li>
                  <li class="nav-item"><a class="nav-link btn btn-social btn-twitter" target="_social" href="https://twitter.com/orangecyberdef" rel="noopener noreferrer"><span class="sr-only">Twitter</span></a></li>
                  <li class="nav-item"><a class="nav-link btn btn-social btn-linkedin" target="_social" href="https://www.linkedin.com/company/orange-cyberdefense/" rel="noopener noreferrer"><span class="sr-only">Linkedin</span></a></li>
                </ul>
            </div>
            <div class="row mb-0 pt-2 pl-3">
                If you identify a vulnerability with this portal please email us at &nbsp;<a href="mailto:infosec@orangecyberdefense.com"> infosec@orangecyberdefense.com</a>
            </div>
        </div>
    </div>
  </div>
